import React, { useCallback, useEffect, useRef, useState } from 'react';
import T from 'prop-types';

import PageModal from '../../../../../components/Modals/PageModal';

const TakeawaysContent = ({
  pending,
  key_takeaways,
}) => {
  const takeawaysContentRef = useRef();

  const [showViewMore, setShowViewMore] = useState(false);
  const [openTakeAwaysModal, setTakeAwaysModal] = useState(false);

  const calculateOverflow = useCallback(() => {
    if (takeawaysContentRef.current) {
      const { scrollHeight, clientHeight } = takeawaysContentRef.current;
      setShowViewMore(scrollHeight > clientHeight);
    }
  }, []);

  useEffect(() => {
    calculateOverflow();
  }, [key_takeaways]);

  useEffect(() => {
    takeawaysContentRef.current?.addEventListener('resize', calculateOverflow);
    return () => {
      takeawaysContentRef.current?.removeEventListener('resize', calculateOverflow);
    };
  }, []);

  return (
    <>
      <div
        ref={takeawaysContentRef}
        className="forecasts-main-sidebar__takeaways-content forecasts-takeaways-css-normalize"
        dangerouslySetInnerHTML={{ __html: key_takeaways }}
      />

      {!pending && showViewMore && (
        <div
          className="forecasts-main-sidebar__takeaways-view-more"
          onClick={() => setTakeAwaysModal(true)}
        >
          View more
        </div>
      )}

      <PageModal
        open={openTakeAwaysModal}
        header="Key Takeaways"
        main={(
          <div
            className="forecasts-takeaways-modal__content forecasts-takeaways-css-normalize"
            dangerouslySetInnerHTML={{ __html: key_takeaways }}
          />
        )}
        className="forecasts-takeaways-modal"
        onClose={() => setTakeAwaysModal(false)}
      />
    </>
  );
};

TakeawaysContent.propTypes = {
  pending: T.bool,
  key_takeaways: T.string,
};

export default TakeawaysContent;
